"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressStatusType = void 0;
var ProgressStatusType;
(function (ProgressStatusType) {
    ProgressStatusType["TIMEOUT"] = "timeout";
    ProgressStatusType["PENDING"] = "pending";
    ProgressStatusType["FAILED"] = "failed";
    ProgressStatusType["COMPLETE"] = "complete";
    ProgressStatusType["STARTED"] = "started";
    ProgressStatusType["WRITING"] = "writing";
    ProgressStatusType["ERROR"] = "error";
    ProgressStatusType["NONE"] = "";
})(ProgressStatusType = exports.ProgressStatusType || (exports.ProgressStatusType = {}));
//# sourceMappingURL=ProgressStatusType.js.map